module.exports = __webpack_public_path__ + "static/media/iso-login.6b1b9962.svg";